const truncateString = (value, lengthInitial, lengthFinal) => {
  return value.substring(0, lengthInitial) + '...' + value.substring(value.length - lengthFinal, value.length)
}

export {
  truncateString
}



// WEBPACK FOOTER //
// ./client/utils/truncateString.js